import { connect } from "react-redux";
import { tasks, getError } from "../../store/selectors/scope.selector";
import {
  updateTask,
  updateTaskStatus,
  createTask,
  deleteTask,
} from "../../store/actions/scope.actions";

import KanbanBoard from "./KanbanBoard";
const mapDispatchToProps = {
  updateTaskRequest: updateTask,
  updateTaskStatusRequest: updateTaskStatus,
  createTaskRequest: createTask,
  deleteTaskRequest: deleteTask,
};
const mapStateToProps = (state) => {
  const tasksList = tasks(state);
  const error = getError(state);

  return { tasksList, error };
};

export default connect(mapStateToProps, mapDispatchToProps)(KanbanBoard);
